/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=solid&m=free */

import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faArrowDownLong,
    faArrowLeft,
    faArrowRight,
    faArrowTrendDown,
    faArrowTrendUp,
    faBagShopping,
    faBars,
    faBolt,
    faBookOpen,
    faBox,
    faBoxArchive,
    faBoxes,
    faCalendar,
    faCartPlus,
    faCartShopping,
    faCashRegister,
    faChartArea,
    faChartBar,
    faChartColumn,
    faChartLine,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleMinus,
    faCircleXmark,
    faClipboardList,
    faClock,
    faColumns,
    faCommentAlt,
    faCreditCard,
    faDatabase,
    faDollarSign,
    faDownload,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExpandAlt,
    faExpandArrowsAlt,
    faFileExcel,
    faFileLines,
    faFilePdf,
    faFlag,
    faGripVertical,
    faHandHoldingDollar,
    faInfoCircle,
    faLink,
    faLock,
    faLongArrowAltRight,
    faMapMarkerAlt,
    faMinus,
    faMobileScreenButton,
    faMoneyBill,
    faMoneyBill1,
    faMoneyCheck,
    faMoneyCheckDollar,
    faMousePointer,
    faPen,
    faPercentage,
    faPerson,
    faPlus,
    faPlusCircle,
    faPrint,
    faQrcode,
    faReceipt,
    faRemove,
    faReply,
    faSave,
    faSearch,
    faShapes,
    faShield,
    faSliders,
    faStore,
    faTable,
    faTachometerAlt,
    faTag,
    faTicketSimple,
    faTimes,
    faToolbox,
    faTrash,
    faUpload,
    faUser,
    faUserCircle,
    faUserPlus,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';

export const fontAwesomeSolidIcons = {
    faAngleDown,
    faAngleUp,
    faAngleRight,
    faAngleLeft,
    faArrowLeft,
    faBagShopping,
    faBars,
    faBolt,
    faBookOpen,
    faBoxes,
    faToolbox,
    faCartPlus,
    faMoneyCheckDollar,
    faChartArea,
    faChartBar,
    faChartPie,
    faChartColumn,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleXmark,
    faClipboardList,
    faClock,
    faColumns,
    faDollarSign,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExpandAlt,
    faExpandArrowsAlt,
    faFileExcel,
    faFileLines,
    faFilePdf,
    faFlag,
    faGripVertical,
    faHandHoldingDollar,
    faInfoCircle,
    faLink,
    faLock,
    faQrcode,
    faLongArrowAltRight,
    faMapMarkerAlt,
    faMobileScreenButton,
    faCircleMinus,
    faMoneyBill,
    faMoneyCheck,
    faMoneyBill1,
    faMousePointer,
    faPen,
    faPercentage,
    faPerson,
    faPlus,
    faPlusCircle,
    faReceipt,
    faRemove,
    faReply,
    faSearch,
    faSave,
    faTable,
    faTachometerAlt,
    faTag,
    faTicketSimple,
    faTimes,
    faTrash,
    faUser,
    faUserPlus,
    faUserCircle,
    faArrowTrendDown,
    faArrowTrendUp,
    faCommentAlt,
    faArrowDownLong,
    faDownload,
    faUpload,
    faCartShopping,
    faMinus,
    faBoxArchive,
    faPrint,
    faCalendar,
    faBox,
    faCashRegister,
    faCreditCard,
    faStore,
    faUsers,
    faSliders,
    faShapes,
    faShield,
    faArrowRight,
    faDatabase,
    faChartLine,
};
